import { Pipe, PipeTransform } from '@angular/core';
import { parse } from 'marked';

@Pipe({
    name: 'marked',
    standalone: false
})
export class MarkedPipe implements PipeTransform {
  transform(value: any): any {
    if (value && value.length > 0) {
      const md = parse(value);

      return md;
    }
    return value;
  }
}
